import loadData from './load-data';
import core_viz from './core-viz';
import track from './track';
import love_hate from './love-hate';
import comm from './community';
import comm_bars from './community-bars';
import health_globe from './health-globe';
import health_bars from './health-bars';
import routine from './routine';
import aspiration from './aspirations';
import util from './_utils';

let doc = {},
	translations;

const core_viz_panel = d3.select('.graphic__right.core-viz'),
	health_panel = d3.select('.graphic__right.health'),
	routine_panel = d3.select('.graphic__right.routine'),
	community_panel = d3.select('.graphic__right.community'),
	aspirations_panel = d3.select('.graphic__right.aspirations');

function resize() {
	const story_location = util.getStoryLocation();

	core_viz.resize();
	comm.setup();
	comm_bars.setup(true);
	// track.setup(true);
	// love_hate.setup();
	routine.setup();
	health_globe.setup();
	aspiration.setup();

	if (story_location.current_chapter === 'love-hate') {
		// love_hate.resizeLH();
		love_hate.setup(true);
		// track.resizeTrack();
		track.setup(true);
	};

	if (story_location.current_chapter === 'health') {
		health_globe.rebuild()
		health_bars.setup(true);
	};

	if (story_location.current_chapter === 'community') {
		comm.resizeComm()
		comm_bars.resizeBars();
	};

	if (story_location.current_chapter === 'routine') {
		routine.build()
	};

	if (story_location.current_chapter === 'aspirations') {
		aspiration.clear();
		aspiration.next(-1);
		util.skipStep(-1);
	};
	//health_globe.resize();
}

function init() {
	return new Promise((resolve, reject) => {
		loadData(['doc.json', 'translations.csv', 'core-viz.json', 'health.json', 'routine.json', 'community.json', 'aspirations.json']).then(result => {
			doc.doc = result[0];
			translations = result[1];
			doc['core-viz'] = result[2];
			doc.health = result[3];
			doc.routine = result[4];
			doc.community = result[5];
			doc.aspirations = result[6];

			util.rightPanelUpdate(core_viz_panel, core_viz_panel.select('.rp__content'), 'core-viz', doc);
			util.rightPanelUpdate(health_panel, health_panel.select('.rp__content'), 'health', doc);
			util.rightPanelUpdate(routine_panel, routine_panel.select('.rp__content'), 'routine', doc);
			util.rightPanelUpdate(community_panel, community_panel.select('.rp__content'), 'community', doc);
			util.rightPanelUpdate(aspirations_panel, aspirations_panel.select('.rp__content'), 'aspirations', doc);

			resolve();
		}).catch(console.error);
	})
}

function getVizTranslations() {
	return translations;
}

function updatePanelContent(chapter) {
	util.rightPanelUpdate(d3.select(`.graphic__right.${chapter}`), d3.select(`.graphic__right.${chapter}`).select('.rp__content'), chapter, doc);
}

function skipPanelContent(chapter) {
	util.rightPanelUpdate(d3.select(`.graphic__right.${chapter}`), d3.select(`.graphic__right.${chapter}`).select('.rp__content'), chapter, doc);
}

function updateGraphicContent(chapter, step = -1) {
	//bottom panel stuff
	const bottomPanel = d3.select('.bottom__panel'),
		cvBottomPanel = bottomPanel.select('.bottom__panel-cv'),
		healthBottomPanel = bottomPanel.select('.bottom__panel-health'),
		routineBottomPanel = bottomPanel.select('.bottom__panel-routine'),
		communityBottomPanel = bottomPanel.select('.bottom__panel-community'),
		aspirationsBottomPanel = bottomPanel.select('.bottom__panel-aspirations'),
		aspirationsTopPanel = d3.select('.top-panel');

	cvBottomPanel.classed('is-visible', chapter === 'core-viz' && step >= 0);
	cvBottomPanel.classed('is-visible', chapter === 'core-viz' && step >= 0);

	healthBottomPanel.classed('is-visible', chapter === 'health');

	communityBottomPanel.classed('is-visible', chapter === 'community');

	routineBottomPanel.classed('is-visible', chapter === 'routine');
	routineBottomPanel.select('.bottom__panel-routine-habit').classed('is-visible', chapter === 'routine' && step == -1);
	routineBottomPanel.select('.bottom__panel-routine-time').classed('is-visible', chapter === 'routine' && step == 0);
	routineBottomPanel.select('.bottom__panel-routine-coping').classed('is-visible', chapter === 'routine' && step == 1);

	aspirationsBottomPanel.classed('is-visible', chapter === 'aspirations'),
		aspirationsTopPanel.classed('is-visible', chapter === 'aspirations');

	//other stuff
	const cvDropdown = d3.select('.cv-dropdown');
	cvDropdown.classed('is-visible', chapter === 'core-viz' && step >= 0);
	cvDropdown.classed('is-clickable', chapter === 'core-viz' && step >= 1);
}

export default {
	init,
	resize,
	updatePanelContent,
	getVizTranslations,
	updateGraphicContent
};